"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = __importDefault(require("react"));

const styles_1 = require("./styles");

const GridBody_1 = require("./GridBody");

const GridHeader_1 = require("./GridHeader");

const Grid = props => {
  const {
    data,
    bgColor,
    children,
    stickyHeader,
    top,
    loading,
    emptyData,
    selectedItem: activeItem,
    onSelectItem,
    comparisonProperty,
    onSelectCell
  } = props;
  const [selectedItem, setSelectedItem] = react_1.default.useState(-1);
  react_1.default.useEffect(() => {
    if (typeof activeItem === 'undefined' || Object.entries(activeItem).length === 0 || !data || data.length === 0) {
      return setSelectedItem(-1);
    }

    const selectedItemId = data === null || data === void 0 ? void 0 : data.findIndex(item => typeof comparisonProperty === 'string' && comparisonProperty.trim().length > 0 ? item[comparisonProperty] === activeItem[comparisonProperty] : item === activeItem);

    if (selectedItemId !== selectedItem) {
      return setSelectedItem(selectedItemId);
    } // eslint-disable-next-line

  }, [activeItem]);
  const onItemSelect = react_1.default.useCallback((itemIndex, e) => {
    e === null || e === void 0 ? void 0 : e.preventDefault();

    if (!data) {
      return;
    }

    if (onSelectItem) {
      return onSelectItem(data[itemIndex], e);
    }

    if (!onSelectCell) {
      return setSelectedItem(itemIndex);
    }

    return;
  }, // eslint-disable-next-line
  [data]);
  const onCellSelect = react_1.default.useCallback((itemIndex, column, e) => {
    e === null || e === void 0 ? void 0 : e.preventDefault();

    if (!data || typeof onSelectCell === 'undefined') {
      return;
    }

    return onSelectCell(data[itemIndex], column, e);
  }, // eslint-disable-next-line
  [data]);

  if (!children && !data) {
    return null;
  }

  let gridTemplateColumns;

  if (children) {
    gridTemplateColumns = react_1.default.Children.map(children, child => {
      const {
        title,
        width,
        minWidth
      } = child.props;

      if (width) {
        return width;
      }

      if (minWidth) {
        return `minmax(${minWidth}, 1fr)`;
      }

      return `minmax(${(title ? title === null || title === void 0 ? void 0 : title.length : 0) * 7.6 + 10}px, 1fr)`;
    }).join(' ');
  }

  return (0, jsx_runtime_1.jsxs)(styles_1.StyledGrid, Object.assign({
    role: "grid",
    "aria-label": "grid",
    bgColor: bgColor,
    stickyHeader: stickyHeader,
    top: top
  }, {
    children: [(0, jsx_runtime_1.jsx)(GridHeader_1.GridHeader, Object.assign({
      gridTemplateColumns: gridTemplateColumns
    }, props), void 0), (0, jsx_runtime_1.jsx)(GridBody_1.GridBody, {
      data: data,
      columns: children,
      bgColor: bgColor,
      loading: loading,
      emptyData: emptyData,
      selectedItem: selectedItem,
      onSelect: onItemSelect,
      dataAttr: comparisonProperty,
      onCellSelect: onCellSelect,
      gridTemplateColumns: gridTemplateColumns
    }, void 0)]
  }), void 0);
};

Grid.Column = GridHeader_1.GridHeaderColumn;
exports.default = Grid;